import { CAS as CASModule } from '../../CIMSModule/instances'
import { CIMSPage } from '../../cimsPage'
import { Permission } from '../../permission'
import { RoleTemplateItem } from '../RoleTemplateItem'

const CAS = 'Construction & Admin Submittal'
const CASWF = `${CAS}s workflow`

export const CASAdmin = new RoleTemplateItem({
  id: 'a4f6f871-5e82-4de6-9ad4-b2a9d2f62f20',
  name: `${CAS} Admin`,
  description: `Gives users access to all permissions within the ${CASWF}`,
  module: CASModule,
  permissionItems: Permission.findByModule(CASModule),
})

export const CASRouter = new RoleTemplateItem({
  id: 'b300edbe-061c-4184-93c0-556d819caa45',
  name: `${CAS} Router`,
  description: `Allows users to Route submitted submittals to the corresponding groups for review in the ${CASWF}`,
  module: CASModule,
  permissionItems: [
    Permission.ViewConstructionAdminSubmittal,
    Permission.GroupReviewConstructionAdminSubmittal,
    Permission.CommentOnConstructionAdminSubmittal,
    Permission.EditConstructionAdminSubmittal,
    Permission.EditNumberNameConstructionAdminSubmittal,
    Permission.GiveDispositionConstructionAdminSubmittal,
    Permission.ReviewAllConstructionAdminSubmittal,
    Permission.RevertConstructionAdminSubmittal,
    Permission.RouteConstructionAdminSubmittal,
    Permission.RemoveRestoreConstructionAdminSubmittal,
    Permission.CreateCASRoutingGroup,
    Permission.EditCASRoutingGroup,
    Permission.RemoveRestoreCASRoutingGroup,
    ...Permission.findByPage(CIMSPage.CASQuickLinks),
    ...Permission.findByPage(CIMSPage.CASNotifications),
    ...Permission.findByPage(CIMSPage.CASDispositionTypes),
  ],
})

export const CASGroupReviewer = new RoleTemplateItem({
  id: '1c2ca8e9-beeb-4da9-a011-1f5bf05161db',
  name: `${CAS} Group Reviewer`,
  description: `Allows users to Approve or Reject submittals for their assigned group when in Group Review status in the ${CASWF}`,
  module: CASModule,
  permissionItems: [
    Permission.GroupReviewConstructionAdminSubmittal,
    Permission.ViewConstructionAdminSubmittal,
    Permission.CommentOnConstructionAdminSubmittal,
  ],
})

export const CASContractor = new RoleTemplateItem({
  id: 'ab724204-e707-4181-a6e8-2bdf898cafdc',
  name: `${CAS} Contractor`,
  description: `Allows users to Create, Revise, or Comment on ${CAS}s`,
  module: CASModule,
  permissionItems: [
    Permission.ViewConstructionAdminSubmittal,
    Permission.CommentOnConstructionAdminSubmittal,
    Permission.CreateConstructionAdminSubmittal,
    Permission.ReviseConstructionAdminSubmittal,
    Permission.RemoveRestoreConstructionAdminSubmittal,
  ],
})

export const CASREReviewer = new RoleTemplateItem({
  id: '6e00ba98-acd4-45e6-81f3-84f72577d5e5',
  name: `${CAS} RE Reviewer`,
  description: `Allows users to reject or give disposition to submittals at RE review status in the ${CASWF}`,
  module: CASModule,
  permissionItems: [
    Permission.ViewConstructionAdminSubmittal,
    Permission.GroupReviewConstructionAdminSubmittal,
    Permission.CommentOnConstructionAdminSubmittal,
    Permission.GiveDispositionConstructionAdminSubmittal,
    Permission.ReviewAllConstructionAdminSubmittal,
    Permission.RevertConstructionAdminSubmittal,
    Permission.RemoveRestoreConstructionAdminSubmittal,
    ...Permission.findByPage(CIMSPage.CASDispositionTypes),
  ],
})

export type CASRoleTemplateItem =
  | typeof CASAdmin
  | typeof CASRouter
  | typeof CASGroupReviewer
  | typeof CASContractor
  | typeof CASREReviewer
